import React, { useState } from 'react'
import {
  CButton,
  CCol,
  CFormCheck,
  CFormInput,
  CFormLabel,
  CModal,
  CModalBody,
  CModalFooter,
  CRow,
} from '@coreui/react'
import { CustomDescriptionBox } from '../../../components'
import InfoIcon from '../../../assets/info-icon.svg'

const LiveStreamCreateModal = (props) => {
  const {
    isEdit,
    onCancel,
    onNext,
    name,
    setName,
    description,
    setDescription,
    location,
    recording,
    setRecording,
  } = props

  const [errorData, setErrorData] = useState({})

  const validateInfo = () => {
    let isFormValid = true
    let temp = {}

    if (name.trim().length === 0) {
      isFormValid = false
      temp.name = 'Name Cannot be Empty!'
    }
    setErrorData({ ...temp })
    return isFormValid
  }

  const handleSave = () => {
    if (!validateInfo()) return
    onNext()
  }

  return (
    <CModal
      size="lg"
      scrollable
      visible={true}
      alignment="center"
      className="custom-form-name-modal border-0"
    >
      <div
        className="px-5 text-white w-100 d-flex align-items-center"
        style={{ height: '3.8vw', backgroundImage: 'linear-gradient(to bottom, #646464, #111)' }}
      >
        <p style={{ fontSize: '1.5625vw' }} className="mb-0">
          {isEdit ? '' : 'New'} Live Stream Setup
        </p>
      </div>
      <CModalBody className="px-5 py-4">
        <CRow>
          <CCol>
            <CCol>
              <CustomDescriptionBox
                title="Name"
                rows={1}
                limit={65}
                value={name}
                onChange={setName}
                isMandatory={true}
                errorText={errorData.name}
              />
            </CCol>
          </CCol>
        </CRow>
        <CRow>
          <CCol>
            <CCol>
              <CustomDescriptionBox
                title="Description"
                rows={3}
                limit={150}
                value={description}
                onChange={setDescription}
              />
            </CCol>
          </CCol>
        </CRow>

        <CRow className="">
          <CCol className="">
            <CFormLabel>Location</CFormLabel>
            <CFormInput type="text" value={location} disabled />
          </CCol>
        </CRow>
        <CRow className="mt-4">
          <CCol className="d-flex align-items-center">
            <CFormCheck
              label="Enable Recording"
              className="live-comments black-tick-checkbox"
              value={recording}
              checked={recording}
              onChange={(e) => setRecording(e.target.checked)}
            />
            <img
              src={InfoIcon}
              title={`When you enable recording, OTTDock creates an MP4 file for Video-On-Demand (VOD) replay. You'll find the recorded video in Asset Manager with the same name as the Live stream, after the VOD stream processing has finished. This process may take few minutes or hours based on the size of the video file. An average 10 GB video file takes 2 hours to process and store in Asset manager.`}
              alt="InfoIcon"
              className="mx-2 cursor-pointer"
            />
          </CCol>
        </CRow>
      </CModalBody>
      <CModalFooter className="px-5 border-0">
        <CButton
          style={{ color: 'black', border: '1px solid black', fontSize: '.9vw' }}
          className="mx-4 bg-white rounded-1 btn-focus-none px-4"
          type="submit"
          onClick={onCancel}
        >
          Cancel
        </CButton>
        <CButton
          style={{ border: '1px solid black', fontSize: '.9vw' }}
          className=" bg-black rounded-1 btn-focus-none px-4"
          type="submit"
          onClick={handleSave}
        >
          Next
        </CButton>
      </CModalFooter>
    </CModal>
  )
}

export default LiveStreamCreateModal
